<script setup lang="ts">
import Image from "@/assets/images/Anaglyphic_logo.png";
</script>

<template>
	<div>
		<img :src="Image" alt="logo" width="64px" height="64px" />
		<h1>Anaglyphic Report</h1>
	</div>
</template>

<style scoped lang="scss">
div {
	display: flex;
	gap: 1rem;
	justify-content: center;
	align-items: center;
	margin-top: 1rem;
	text-align: center;
	background: #228ae6;
	border-radius: 0.5rem;
	margin-inline: 8px;
	padding: 1rem;
	width: 793px !important;
}

h1 {
	color: white;
}
</style>
